//LightSlider settings ------------------------------------------------------------------------------------------------------------------------------

jQuery(document).ready(function($){
    $('.image-gallery').lightSlider({ 
    gallery:false, 
    item:1, //number of slides to show at a time
    mode: "fade",
    useCSS: true,
    cssEasing: 'ease', //'cubic-bezier(0.25, 0, 0.25, 1)',//
    pause: 4000,
    speed: 1000, //ms'
    auto:true, 
    loop:true,
    slideEndAnimation: true, 
    thumbItem: 9,
    item:1,
    adaptiveHeight:false,
    pauseOnHover: true,
    slideMargin: 0,
    autoWidth: true,
    controls: false,
    pager:false
    });
    });

    jQuery(document).ready(function($){
        $('.text-gallery').lightSlider({ 
            auto:true,
            pause: 3000,
            loop:true,
            item:1,
            slideMargin: 0,
            pauseOnHover: true,
        onBeforeSlide: function (el) {
            $('#current').text(el.getCurrentSlideCount());
        } 
        });
        });
// Picture Gallery

jQuery(document).ready(function($){    
   
	// Target Slider
	$('.picture-gallery').lightSlider({ 
        gallery:true,
        item:1,
        auto: true,
        loop:true,
        thumbItem:9,
        slideMargin:0,
        enableDrag: true,
        easing: 'cubic-bezier(0.25, 0, 0.25, 1)',
        speed:600,
        pause: 4000,
        currentPagerPosition:'middle',
        

		// On the LightSlider Load also load the Lightbox Magnific PopUp.						  
		// onSliderLoad: function() {  
				
		// 	$('.picture-gallery').magnificPopup({ 
		// 		delegate: 'a', 
		// 		type: 'image',
		// 			gallery:{
		// 		    enabled:true,
		// 		    navigateByImgClick: true,
		// 			preload: [0,1] // Will preload 0 - before current, and 1 after the current image

		// 	  	},
		// 	  	zoom: {
		// 		    enabled: true, // By default it's false, so don't forget to enable it
		// 		    duration: 300, // duration of the effect, in milliseconds
		// 		    easing: 'ease-in-out', // CSS transition easing function
		// 		}
		// 	});
        //  } 
	});

});

        // Google Maps
        (function( $ ) {

            /**
             * initMap
             *
             * Renders a Google Map onto the selected jQuery element
             *
             * @date    22/10/19
             * @since   5.8.6
             *
             * @param   jQuery $el The jQuery element.
             * @return  object The map instance.
             */
            function initMap( $el ) {
            
                // Find marker elements within map.
                var $markers = $el.find('.marker');
            
                // Create gerenic map.
                var mapArgs = {
                    zoom        : $el.data('zoom') || 16,
                    mapTypeId   : google.maps.MapTypeId.ROADMAP,
                    mapTypeControl: false,
                    styles: [
                        {
                            "featureType": "landscape.natural",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "color": "#e0efef"
                                }
                            ]
                        },
                        {
                            "featureType": "poi",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "hue": "#1900ff"
                                },
                                {
                                    "color": "#c0e8e8"
                                }
                            ]
                        },
                        {
                            "featureType": "poi.business",
                            "elementType": "labels",
                            "stylers": [
                              {
                                "visibility": "off"
                              }
                            ]
                          },
                        {
                            "featureType": "road",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "lightness": 100
                                },
                                {
                                    "visibility": "simplified"
                                }
                            ]
                        },
                        {
                            "featureType": "road",
                            "elementType": "labels",
                            "stylers": [
                                {
                                    "visibility": "off"
                                }
                            ]
                        },
                        {
                            "featureType": "transit.line",
                            "elementType": "geometry",
                            "stylers": [
                                {
                                    "visibility": "on"
                                },
                                {
                                    "lightness": 700
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "color": "#7dcdcd"
                                }
                            ]
                        }
                    ]

                };
                var map = new google.maps.Map( $el[0], mapArgs );
            
                // Add markers.
                map.markers = [];
                $markers.each(function(){
                    initMarker( $(this), map );
                });
            
                // Center map based on markers.
                centerMap( map );
            
                // Return map instance.
                return map;
            }
            
            /**
             * initMarker
             *
             * Creates a marker for the given jQuery element and map.
             *
             * @date    22/10/19
             * @since   5.8.6
             *
             * @param   jQuery $el The jQuery element.
             * @param   object The map instance.
             * @return  object The marker instance.
             */
            function initMarker( $marker, map ) {
            
                // Get position from marker.
                var lat = $marker.data('lat');
                var lng = $marker.data('lng');
                var latLng = {
                    lat: parseFloat( lat ),
                    lng: parseFloat( lng )
                };
                var icon = {
                    url: $marker.attr('data-icon'), // url
                    scaledSize: new google.maps.Size(50, 50), // experiment with these values until you're satisfied
                    // origin: new google.maps.Point(0,0), // set the base origin
                    // anchor: new google.maps.Point(0, 0) // set the base anchor
                };
        
            
                // Create marker instance.
                var marker = new google.maps.Marker({
                    position : latLng,
                    map: map,
                    icon: icon
                });
            
                // Append to reference for later use.
                map.markers.push( marker );
            
                // If marker contains HTML, add it to an infoWindow.
                if( $marker.html() ){
            
                    // Create info window.
                    var infowindow = new google.maps.InfoWindow({
                        content: $marker.html()
                    });
            
                    // Show info window when marker is clicked.
                    google.maps.event.addListener(marker, 'click', function() {
                        infowindow.open( map, marker );
                    });
                }
            }
            
            /**
             * centerMap
             *
             * Centers the map showing all markers in view.
             *
             * @date    22/10/19
             * @since   5.8.6
             *
             * @param   object The map instance.
             * @return  void
             */
            function centerMap( map ) {
            
                // Create map boundaries from all map markers.
                var bounds = new google.maps.LatLngBounds();
                map.markers.forEach(function( marker ){
                    bounds.extend({
                        lat: marker.position.lat(),
                        lng: marker.position.lng()
                    });
                });
            
                // Case: Single marker.
                if( map.markers.length == 1 ){
                    map.setCenter( bounds.getCenter() );
            
                // Case: Multiple markers.
                } else{
                    map.fitBounds( bounds );
                }
            }
            
            // Render maps on page load.
            $(document).ready(function(){
                $('.acf-map').each(function(){
                    var map = initMap( $(this) );
                });
            });
            
            })(jQuery);
/*
Accordian
*
*
*
*/
jQuery(document).ready(function($){
    $('.toggle-contact').click(function() {
    
      if ($('#homepage-contactform-container').hasClass('show')) {
        $('#homepage-contactform-container').removeClass('show');
        $('#homepage-contactform-container').slideUp(350);
        $('.twobar')
        .removeClass('cross')
        .addClass('arrow');
      } else {
        $('#homepage-contactform-container').removeClass('show');
        $('#homepage-contactform-container').slideUp(350);
        $('#homepage-contactform-container').toggleClass('show');
        $('#homepage-contactform-container').slideToggle(350);
        $('.twobar')
        .removeClass('arrow')
        .addClass('cross');
      }
    

    });
    });

    
// Floorplan Map

            var svgRooms = document.querySelectorAll("#rooms > *");

            svgRooms.forEach(function(el) {
            
              el.addEventListener("mouseenter", function() {
                var roomId = el.getAttribute("id");
                var imageRoom = document.querySelector("[data-room='" + roomId + "']");
                el.classList.add("on");
                if ( imageRoom ) {
                imageRoom.classList.add("on");
                }
              });
            
              el.addEventListener("mouseleave", function() {
                var roomId = el.getAttribute("id");
                var imageRoom = document.querySelector("[data-room='" + roomId + "']");
                el.classList.remove("on");
                if ( imageRoom ) {
                imageRoom.classList.remove("on");
                }
              });
            
            });


// Cross to Arrow 
// jQuery(document).ready(function($){
// $('.cross').click(function() {
//     $('.twobar')
//       .removeClass('cross')
//       .addClass('arrow');
//   });

  
//   // Arrow to Hamburger 
//   $('.arrow').click(function() {
//     $('.twobar')
//       .removeClass('arrow')
//       .addClass('cross');
//   });
// });
  